var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMeshIconWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      background: "#fff"
    }
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h60v60H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.873 47.829c-.272-.49-.51-.998-.707-1.518-.817-2.15-1.062-4.467-1.219-6.767l-.037-.575c-.466-7.347-1.653-14.923-.404-22.173l.073-.41c.402-2.168.407-4.3 1.677-5.72l.103-.11.103-.103c.247-.237.532-.453.873-.64 1.643-1.472 4.135-1.717 6.237-1.045 2.101.672 3.862 2.135 5.36 3.755 2.86 3.093 4.98 6.948 5.634 11.11.298 1.894.292 3.82.266 5.74l-.005.383c-.032 2.351-.065 4.703-.222 7.05-.263 3.937-.94 8.02-3.258 11.214-2.317 3.194-6.68 5.195-10.335 3.709-1.654-.673-2.968-1.967-3.907-3.503l-.093-.154-.139-.243z",
    fill: "#F2E35A",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.867 47.49a19.333 19.333 0 01-.757-1.755c-1.739-4.613-2.439-9.552-2.816-14.468l-.047-.64c-.316-4.487-.312-9.069 1.056-13.346.623-1.951 1.337-3.645 2.308-5.071l.14-.202.11-.153c1.23-1.673 2.858-2.948 5.195-3.786 2.753-1.362 5.365-.367 7.217 1.987l.086.111.089.116a6.8 6.8 0 01.174.238c1.864 2.686 2.298 6.088 2.52 9.35.418 6.136.28 12.3-.092 18.44l-.049.764c-.195 2.893-.548 5.844-1.87 8.384l-.118.223-.084.151c-.056.1-.113.2-.174.3-1.768 2.9-5.43 4.934-8.617 3.755-1.822-.674-3.106-2.207-4.043-3.956l-.082-.155-.146-.286z",
    fill: "#1AD4E5",
    style: {
      mixBlendMode: "darken"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.946 47.947c-.401 1.01-.974 1.922-1.803 2.654-3.045 2.691-8.178 1.373-10.795-1.737-2.616-3.11-3.316-7.37-3.674-11.42a102.236 102.236 0 01-.102-16.738l.031-.393c.327-3.945 1.114-8.16 4.006-10.805l.146-.13-.052.068c1.311-1.265 2.977-2.146 4.78-2.35 2.783-.312 5.775 1.181 6.888 3.75.136.314.242.637.328.965l.05.198.064.286c.138.67.211 1.357.277 2.038.89 9.225 1.161 18.511.809 27.773-.07 1.814-.219 3.746-.805 5.443l-.083.23-.065.168z",
    fill: "#FD5794",
    style: {
      mixBlendMode: "darken"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3 20.648c-.221-3.261-.655-6.664-2.52-9.35-.084-.122-.173-.238-.262-.354-1.372 1.417-1.367 3.605-1.78 5.83-1.367 7.374-.143 15.097.331 22.583.158 2.488.372 5.012 1.257 7.342.23.606.514 1.198.846 1.76 1.541-2.81 1.843-6.153 2.037-9.371.371-6.14.51-12.303.092-18.44",
    fill: "#029102"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.784 12.312l.064.285c.138.669.211 1.357.277 2.038.89 9.225 1.161 18.511.809 27.773-.07 1.814-.219 3.746-.805 5.443l-.082.226-.145-.284a19.333 19.333 0 01-.757-1.756c-1.739-4.613-2.439-9.552-2.816-14.468l-.047-.64-.043-.642c-.27-4.28-.203-8.63 1.099-12.704.623-1.951 1.337-3.645 2.308-5.071l.138-.2z",
    fill: "#4B3C8C"
  }))));
}

export default SvgMeshIconWhite;